import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { FriendBalloon } from '../../shared/FriendBalloon';
import { Photo } from '../../shared/Photo';

export const MessageToPersonHintDialog: React.FC = () => {
  const { t } = useTranslation('best_friends');
  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;

          h1 {
            color: #4d3906;
            font-size: 20px;
            text-align: center;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .photo {
            width: 278px;
            height: 180px;
            margin: 32px auto;
            position: relative;
          }
          .balloon {
            position: absolute;
            top: 32px;
            right: -16px;
            transform: rotate(2deg);
            filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0.2));
          }
          .left-rotate {
            transform: rotate(-2deg);
          }
          /* less than iPhone6/7/8 display size */
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 18px;
            }
            .photo {
              width: 214px;
              height: 140px;
            }
          }
        `}
      >
        <h1>{t('help_message_to_person')}</h1>
        <section>
          <div className="photo left-rotate">
            <Photo
              srcSet={`
              /images/best-friends/img_person_hint_01-2x.jpg 2x,
              /images/best-friends/img_person_hint_01.jpg 1x
              `}
            />
            <div className="balloon">
              <FriendBalloon text={t('chat:hint_balloon_text')} isDM={true} />
            </div>
          </div>
          <p>{t('help_message_to_person_desc_01')}</p>
        </section>
      </div>
    </Dialog>
  );
};
